import { Injectable, inject } from '@angular/core';
import {MessageService} from "primeng/api";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ProgressService {
    private messageService = inject(MessageService);

    private dataStore: {blocked: boolean, progressMessage: string} = {blocked: false, progressMessage: null};
    private _blocked: BehaviorSubject<boolean> = new BehaviorSubject(this.dataStore.blocked);
    public readonly blocked: Observable<boolean> = this._blocked.asObservable();
    private _progressMessage: BehaviorSubject<string> = new BehaviorSubject(this.dataStore.progressMessage);
    public readonly progressMessage: Observable<string> = this._progressMessage.asObservable();

    blockWithMessage(message: string) {
      this.dataStore.blocked = true;
      this.dataStore.progressMessage = message;
      this._blocked.next(this.dataStore.blocked);
      this._progressMessage.next(this.dataStore.progressMessage);
    }

    unBlock() {
        this.dataStore.blocked = false;
        this.dataStore.progressMessage = null;
        this._blocked.next(this.dataStore.blocked);
        this._progressMessage.next(this.dataStore.progressMessage);
    }

}
